import { Box, Button, Grid, Paper, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import PageContainer from '../components/PageContainer';
import { Link as RouterLink } from 'react-router';
import VerifiedIcon from '@mui/icons-material/Verified';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BusinessIcon from '@mui/icons-material/Business';
import { APP_NAME, APP_TAGLINE } from '../brand';

export default function Landing() {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', py: { xs: 6, md: 10 }, bgcolor: 'background.paper' }}>
        <PageContainer>
          <Stack spacing={2} alignItems="flex-start" sx={{ maxWidth: 640 }}>
            <Typography variant="h3" component="h1" sx={{ fontWeight: 600, lineHeight: 1.2, color: 'text.primary', fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' } }}>
              {APP_NAME}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6 }}>
              {APP_TAGLINE}. Cada organización configura sus propias tarifas por empresa y CAMARAS
              y administra sus pagos en una plataforma unificada.
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} sx={{ pt: 1, width: 1 }}>
              <Button component={RouterLink} to="/login" variant="contained" color="primary" size="large" sx={{ width: { xs: '100%', sm: 'auto' }, px: 3, py: 1.25 }}>
                Ingresar
              </Button>
            </Stack>
          </Stack>
        </PageContainer>
      </Box>

      <PageContainer sx={{ py: { xs: 4, md: 8 } }}>
        <Grid container spacing={2}>
          {[
            { icon: <BusinessIcon fontSize="small" />, title: 'Multiempresa', text: 'Cada entidad gestiona su panel, empresas y CAMARAS con sus tarifas.', color: 'primary' as const },
            { icon: <CreditCardIcon fontSize="small" />, title: 'Cobros simulados', text: 'Pantalla de Mercado Pago simulada para entornos de test o demo.', color: 'info' as const },
            { icon: <VerifiedIcon fontSize="small" />, title: 'Tarifas vigentes', text: 'Versiones por rango de fechas, con fallback global si la empresa no define una propia.', color: 'success' as const },
            { icon: <LockIcon fontSize="small" />, title: 'Seguridad', text: 'JWT con refresh, control por roles y datos acotados por empresa.', color: 'secondary' as const },
          ].map((feature) => (
            <Grid key={feature.title} size={{ xs: 12, sm: 6, md: 3 }}>
              <Paper sx={{ p: 2.5, height: '100%' }}>
                <Box
                  sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 1.5,
                    color: `${feature.color}.main`,
                    bgcolor: (t) => alpha(t.palette[feature.color].main, 0.12),
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>{feature.title}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>{feature.text}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </PageContainer>

      <Box sx={{ py: 3, textAlign: 'center', borderTop: 1, borderColor: 'divider' }}>
        <Typography variant="caption" color="text.secondary">© {new Date().getFullYear()} {APP_NAME}</Typography>
      </Box>
    </Box>
  );
}
